import React from 'react';

import { ROUTES } from '@routes/constants';

import NavItems from '@components/NavItems';

import Binary from '@assets/BigIcons/Binary';
import Email from '@assets/Icons/Email';
import EmailTemplates from '@assets/Icons/EmailTemplates';
import Form from '@assets/Icons/Form';
import LandingPage from '@assets/Icons/LandingPage';
import LandingPageTempalte from '@assets/Icons/LandingPageTemplate';
import Snippets from '@assets/Icons/Snippets';
import World from '@assets/Icons/World';
import imgLogo from '@assets/Images/marketo_logo.svg';

import styles from './style.module.scss';

const Navbar: React.FC = () => {
  const dataCampaigns = [
    { to: ROUTES.EMAIL_TEMPLATES, label: 'Email Templates', icon: EmailTemplates },
    { to: ROUTES.EMAILS, label: 'Emails', icon: Email },
    { to: ROUTES.FORMS, label: 'Forms', icon: Form },
    { to: ROUTES.LANDING_PAGES_TEMPLATES, label: 'Landing Page Templates', icon: LandingPageTempalte },
    { to: ROUTES.LANDING_PAGES, label: 'Landing Pages', icon: LandingPage },
    { to: ROUTES.SNIPPETS, label: 'Snippets', icon: Snippets },
  ];

  return (
    <nav className={styles.container}>
      <div className={styles.logoContainer}>
        <img src={imgLogo} alt={'logo'} />
      </div>
      <ul>
        <li>
          <NavItems
            dataMainButton={{
              to: ROUTES.PROGRAMS,
              label: 'Marketing Activities',
            }}
          >
            <Binary size={32} />
          </NavItems>
        </li>
        <li>
          <NavItems dataChildren={dataCampaigns}>
            <World size={32} />
            <span className={styles.textToAnimate}>Design Studio</span>
          </NavItems>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
